import {connect} from 'react-redux';

import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../srcCommon/helpers/reselectHelpers';
import {CellsItemsClickEventHandler} from '../../components/inboxes/cells/content/cellsItemsBase';
import {buildActivityDisplay} from '../../helpers/models/visualActivityHelpers';
import {AuditTrailActivity} from '../../models/api/auditTrailActivityModel';
import {ThunkAction} from '../../store/appThunk';
import {getFindTeammate} from '../../store/data/teammates/teammatesSelectors';
import {popoutConversationViewerAction} from '../../store/panels/viewer/viewerPanelActions';
import {getLocalize} from '../../store/stateless/internationalizationSelectors';
import {AuditTrailCell} from './auditTrailCell';

interface AuditTrailActivityCellContainerProps {
  activityDetail: AuditTrailActivity;
  onClick: CellsItemsClickEventHandler<number>;
  isSelected: boolean;
}

/*
 * Selectors.
 */

function getActivityDetail(_state: unknown, props: AuditTrailActivityCellContainerProps) {
  return props.activityDetail;
}

function makeGetActivityDisplayProps() {
  return createSelector(
    [getLocalize, getFindTeammate, getActivityDetail],
    (localize, findTeammate, activityDetail) => {
      const activityDisplay = buildActivityDisplay(localize, findTeammate, activityDetail);
      const {activity} = activityDetail;

      // Title and body are computed in the same way here and in the Notification toast.
      // We control specifically which activity types is displayed here, therefore we know that
      // title and body will be defined.
      const title = activityDisplay?.title || '';
      const body = activityDisplay?.body || '';
      return {
        title,
        body,
        date: activity.date,
        activityId: activity.id,
        conversationId: activity.conversationId,
      };
    },
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<AuditTrailActivityCellContainerProps>()(() => ({
  displayActivity: makeGetActivityDisplayProps(),
}));

const mapDispatchToProps = makeMapDispatchToProps<AuditTrailActivityCellContainerProps>()(() => ({
  onDoubleClick:
    (conversationId: number): ThunkAction =>
    async (dispatch) => {
      dispatch(popoutConversationViewerAction(conversationId));
    },
}));

export const AuditTrailCellContainer = connect(mapStateToProps, mapDispatchToProps)(AuditTrailCell);
